export const XLSX = 'xlsx';
export const XLS = 'xls';
